export const addMouseFlow = () => {
    // @ts-ignore
    window._mfq = window._mfq || [];

    const mf = document.createElement("script");
    mf.type = "text/javascript";
    mf.defer = true;
    mf.src =
        "https://cdn.mouseflow.com/projects/27d3415e-736e-4ff5-9a5c-1aa7729b351d.js";
    document.getElementsByTagName("head")[0].appendChild(mf);

}